
import { TObject } from "../../common/TObject";
import { iData, iDataResult } from "./Data";


export class Routes extends TObject implements iData {

    crmmap: any = null;
    apicall: string = '/routes';
    cache: any = false;
    constructor(crmmap) {
        super(crmmap);
        this.crmmap = crmmap;
        this.cache = false;
    }


    get() {
        return new Promise<iDataResult>((resolve) => {
            if (this.cache) {
                return resolve(this.cache);
            }
            return this.crmmap.APICall(this.apicall).then((data) => {
                this.cache = data;
                this.trigger('refreshed',  this.cache);
                return resolve(this.cache);
            });
        });
    }

    invaledate() {
        this.cache = false;
        this.trigger('invaledate');
    }


    save(slug, data) {
        return this.crmmap.APICall(this.apicall + '/' + encodeURIComponent(slug), () => {
            this.invaledate();
        }, 'POST', data);
    }



    delete(slug) {
        return new Promise<iDataResult>((resolve) => {
            return this.crmmap.APICall(this.apicall+ '/' + encodeURIComponent(slug), null,'delete').then((data) => {
                this.invaledate();
                return resolve(this.cache);
            });
        });
    }

}

